"use strict";

exports.__esModule = true;
exports.hasErrorMessages = void 0;
var hasErrorMessages = function hasErrorMessages(messages) {
  return Array.isArray(messages) && messages.some(function (m) {
    return m.type === 'error';
  });
};
exports.hasErrorMessages = hasErrorMessages;